import React, { useEffect, useMemo, useState } from "react";
import { Button, Badge } from "./ui";
import { MDBContainer, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBRow, MDBCol, MDBSpinner, MDBTooltip, MDBIcon, MDBSwitch } from "mdb-react-ui-kit";
import { Check, RotateCw, Package, RefreshCw, RefreshCcwDotIcon, CalendarDays } from 'lucide-react';
import { api } from "../services";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CheckCircle, FolderSyncIcon as Sync, Calendar, Store, Mail, MapPin, Building2, User, FolderSyncIcon, Info, BookText, ChevronRight, ChevronLeft } from "lucide-react"
import { useParams, useNavigate } from "react-router-dom";
import CatalogItemModal from "./Modals/CatalogItemModal";
import CatalogItemsTable from "./CatalogItemsTable";
import SyncAppModal from "./Modals/SyncAppModal";
import { getImageUrl } from "../utils/utils";
import ConfirmModal from "./Modals/ConfirmModal";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Actionbar from "./Actionbar";
import DeleteModal from "./Modals/DeleteModal";
import CatalogModal from "./Modals/CatalogModal";
import CatalogSyncModal from "./Modals/CatalogSyncModal";
import { usePermission } from "../hooks/usePermission";
import {
  RBAC_MODULES,
  PERMISSION_ACTIONS,
} from "../config/routePermissions";
import {
  isPosReadOnlyEntity,
  isPosIntegrationDeleteLocked,
  posReadOnlyTooltip,
  catalogReadOnlyBannerKey,
  posDeleteLockedTooltip,
} from "../utils/posReadOnly";
import { orderAgentLogoEntries, isOrderAgentPlatform } from "../utils/platformLogos";
import { getLocalizedPlatformName } from "../utils/platformNames";
import { translateProductApiMessage } from "../utils/translateProductApiMessage";
import { fetchPricedAppSources, getUniqueConnectedDeliveryApps } from "../utils/productAppPrice";

const dummyApps = [
    {
        _id: "12321123",
        application: "Jahez",
        sync_time: "2023-09-06",
        sync_status: true,

    },
    {
        _id: "6873b7aeaa72ce079adfd42d",
        application: "Chefz",
        sync_status: false,
    },
    {
        _id: "12321123",
        application: "Keeto",
        sync_status: true,
        sync_time: "2023-12-06",

    },
    {
        _id: "6873b7aeaa72ce079adfd42d",
        application: "Noon"
        ,
        sync_status: false,
        sync_time: "2023-12-06",

    },
     {
        _id: "12321123",
        application: "Keeto",
        sync_status: true,
        sync_time: "2023-12-06",

    },
    {
        _id: "6873b7aeaa72ce079adfd42d",
        application: "Noon"
        ,
        sync_status: false,
        sync_time: "2023-12-06",

    }
]

const platformLogos = {
    JAHEZ: {
      src: "/images/jahez-new-logo.png",
      alt: "Jahez",
      height: "24px",
    },
    "THE CHEFZ": {
      src: "/images/the_chefz_logo.png",
      alt: "The Chefz",
      height: "36px",
    },
    Keeta: {
      src: "/images/keeta.webp",
      alt: "Keeta",
      height: "24px",
    },
    "NINJA  - STAGING": {
    src: "/images/ninja-staging.png",
    alt: "Ninja Staging",
    height: "24px"
  },
  "NINJA": {
    src: "/images/ninja.webp",
    alt: "Ninja",
    height: "24px"
  },
  ...orderAgentLogoEntries("20px"),
  };
const CatalogDetails = () => {
  const { t, i18n } = useTranslation("translation");
  const isArabic  = i18n.language === "ar";
  const { id } = useParams();
  const { can, canAny } = usePermission();
  const canEditCatalog = can(RBAC_MODULES.CATALOG, PERMISSION_ACTIONS.EDIT);
  /** Catalog → platform sync (`/v2.1/catalog/sync`) — `catalog:sync` only, not update. */
  const canSyncCatalog = can(RBAC_MODULES.CATALOG, PERMISSION_ACTIONS.SYNC);
  const canDeleteCatalog = can(RBAC_MODULES.CATALOG, PERMISSION_ACTIONS.DELETE);
  const canMutateCatalogLink = canAny([
    [RBAC_MODULES.PRODUCTS, PERMISSION_ACTIONS.EDIT],
    [RBAC_MODULES.CATALOG, PERMISSION_ACTIONS.EDIT],
  ]);
  const [catalog, setCatalog] = useState(null);
  // Active catalog state removed as it's no longer needed
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
   const [tiles, setTiles] = useState([]);
  const [accountApps, setAccountApps] = useState([]);
  const [addonApps, setAddonApps] = useState([]);
  const deliveryApps = useMemo(
    () => getUniqueConnectedDeliveryApps(accountApps, addonApps),
    [accountApps, addonApps]
  );
  const [showConfirm, setShowConfirm] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    message: "",
    action: () => {},
    actionData: null,
    visibility: null,
  });
  const [submittingAppId, setSubmittingAppId] = useState(null);
  const [isLoading,setIsLoading] = useState(false);
   const [storeId, setStoreId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [modalOpen,setModalOpen] = useState(false)
    const [deleteLoading, setDeleteLoading] = useState(false);
const [deleteError, setDeleteError] = useState(null);
const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
const [selectedItems, setSelectedItems] = useState({ productIds: [] });
const [showDeleteModalforitem, setShowDeleteModalforitem] = useState(false);
const [selectedItemForDelete, setSelectedItemForDelete] = useState(null);
const [selectedTile, setSelectedTile] = useState(null);
const [sortedItems, setSortedItems] = useState([]);
const closeBulkDeteteModal = () => {
  setShowBulkDeleteModal(false);
}
const getPlatformKey = (appName = "") => {
  const upper = appName.toUpperCase();
  if (upper.includes("JAHEZ")) return "JAHEZ";
  if (upper.includes("CHEFZ")) return "THE CHEFZ";
  if (upper.includes("KEETA")) return "Keeta";
  if (upper.includes("NINJA  - STAGING")) return "NINJA  - STAGING";
  if (upper.includes("NINJA")) return "NINJA";
  if (isOrderAgentPlatform(appName)) return "CHAT_AGENT";
  return null;
};
const handleModalOpen = (id) => {
  setShowDeleteModalforitem(true);
  setSelectedItemForDelete(id)
}
const handleRemoveProduct = async () => {
  if (!selectedItemForDelete) return;
  if (isPosReadOnlyEntity(catalog)) return;

  try {
    const token = localStorage.getItem("token");
    await api.delete(`/v2.1/catalog/${id}/product/${selectedItemForDelete}`, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
    });
    
    toast.success(t("Product removed from catalog successfully."));
    await fetchCatalog();
  } catch (error) {
    console.error('Error removing product:', error);
    const errorMessage = error.response?.data?.message || t("Failed to remove product from catalog");
    toast.error(errorMessage);
  } finally {
    setShowDeleteModalforitem(false);
    setSelectedItemForDelete(null);
  }
};
  const [error, setError] = useState("");
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "success",
  });
  const [removeProductError, setRemoveProductError] = useState("");
  const [removeProductSuccess, setRemoveProductSuccess] = useState("");
  const [showCatalogSyncModal, setShowCategorySyncModal] = useState(false);

  const navigate = useNavigate();
  console.log("tiles", tiles);
  
  const WS_URL = process.env.REACT_APP_WS_URL || "ws://localhost:5001";

  const displayCatalogSyncModal = () => {
    setShowCategorySyncModal(true);
  }
// Add these API functions
// Add this function for bulk saving weights
const handleBulkSaveWeights = async () => {
  if (isPosReadOnlyEntity(catalog)) return;
  try {
    // Check for duplicate category weights
    const categoryWeights = sortedItems.map(categoryGroup => categoryGroup.categoryWeight);
    const duplicateCategoryWeights = categoryWeights.filter((weight, index) => 
      weight && categoryWeights.indexOf(weight) !== index
    );
    
    if (duplicateCategoryWeights.length > 0) {
      toast.error(t("Duplicate category weights found. Please ensure all categories have unique weights."), {autoClose: 5000});
      return;
    }
    
    // Check for duplicate product weights within each category
    const duplicateProductWeights = sortedItems.some(categoryGroup => {
      const productWeights = categoryGroup.products.map(product => product.weight);
      return productWeights.some((weight, index) => 
        weight && productWeights.indexOf(weight) !== index
      );
    });
    
    if (duplicateProductWeights) {
      toast.error(t("Duplicate product weights found in one or more categories. Please ensure all products within a category have unique weights."), {autoClose: 5000});
      return;
    }

    const token = localStorage.getItem("token");
    
    // Prepare the payload in the required format
    const payload = {
      itemsSorted: sortedItems.map(categoryGroup => ({
        category: {
          _id: categoryGroup.category._id,
          category_id: categoryGroup.category.category_id,
          name: categoryGroup.category.name,
          index: categoryGroup.category.index,
          exclude_branches: categoryGroup.category.exclude_branches || [],
          appId: categoryGroup.category.appId || null
        },
        categoryWeight: categoryGroup.categoryWeight || 0,
        products: categoryGroup.products.map(product => ({
          product: {
            _id: product.product._id,
            product_id: product.product.product_id,
            name: product.product.name,
            description: product.product.description || "",
            price: product.product.price,
            category_id: product.product.category_id,
            store: product.product.store,
            exclude_branches: product.product.exclude_branches || [],
            availability: product.product.availability,
            image_path: product.product.image_path,
            index: product.product.index,
            calories: product.product.calories,
            is_visible: product.product.is_visible,
            modifiers: product.product.modifiers || [],
            nutrition_facts: product.product.nutrition_facts || {}
          },
          inventory: product.inventory,
          catalogV2ItemId: product.catalogV2ItemId,
          categoryId: product.categoryId,
          catalogItemVisibility: product.catalogItemVisibility,
          weight: product.weight || 0
        }))
      }))
    };

    await api.put(`/catalog/${id}/weightages`, payload, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    toast.success(t("Weights updated successfully"));
    fetchCatalog(); // Refresh data
  } catch (error) {
    toast.error(error.response?.data?.message || t("Failed to update weights"));
  }
};

// Update handleWeightChange to only update local state
const handleWeightChange = (categoryId, productId, value) => {
  if (isPosReadOnlyEntity(catalog)) return;
  const numericValue = value === '' ? '' : Number(value);
  
  // Update category weight
  if (categoryId && productId === null) {
    setSortedItems(prev => prev.map(categoryGroup => {
      if (categoryGroup.category._id === categoryId) {
        return { ...categoryGroup, categoryWeight: numericValue };
      }
      return categoryGroup;
    }));
  }
  
  // Update product weight
  if (productId && categoryId === null) {
    setSortedItems(prev => prev.map(categoryGroup => ({
      ...categoryGroup,
      products: categoryGroup.products.map(product => {
        if (product.product._id === productId) {
          return { ...product, weight: numericValue };
        }
        return product;
      })
    })));
  }
};
  const closeCatalogSyncModal = () => {
    setShowCategorySyncModal(false);
    setSelectedTile(null);
  }

 useEffect(() => {
  fetchCatalog();

  const ws = new WebSocket(WS_URL);

  ws.onopen = () => {
    console.log("Connected to WebSocket");
  };

  ws.onmessage = (event) => {
    console.log("New Message to WebSocket");
    const message = JSON.parse(event.data);

    if (message.type === "MENU_UPDATED") {
      const appName = message.data?.app
        ? translateProductApiMessage(message.data.app, t)
        : t("productApiMsgs.system");
      setNotification({
        show: true,
        message: t("productApiMsgs.menuUpdatedWithApp", { app: appName }),
        type: "success",
      });
      setTimeout(
        () => setNotification({ show: false, message: "", type: "success" }),
        5000
      );
    }

    if (message.type === "MENU_UPDATE_FAILED" || message.type === "MENU_UPDATE_FALLED") {
      const { data } = message;
      console.log("Menu update failed data:", data, message);
      
      const appName = data?.app
        ? translateProductApiMessage(data.app, t)
        : t("productApiMsgs.system");
      const errorCount = data?.error_count || 0;
      const baseMessage = translateProductApiMessage(
        data?.message,
        t
      ) || t("productApiMsgs.menuUpdateFailedRetry");
      
      const errorMessage =
        errorCount > 0
          ? t("productApiMsgs.menuUpdateFailedWithCount", {
              app: appName,
              message: baseMessage,
              count: errorCount,
            })
          : t("productApiMsgs.menuUpdateFailedWithApp", {
              app: appName,
              message: baseMessage,
            });

      setNotification({
        show: true,
        message: errorMessage,
        type: "error",
      });

      setTimeout(
        () => setNotification({ show: false, message: "", type: "error" }),
        8000
      );
    }

    // Handle global error notifications
    if (message.type === "ERROR_NOTIFICATION") {
      const { data } = message;
      console.log("Global error notification:", data);
      
      const errorType = translateProductApiMessage(
        data?.error_type,
        t
      ) || t("productApiMsgs.unknownError");
      const errorMessage = translateProductApiMessage(
        data?.message,
        t
      ) || t("productApiMsgs.anErrorOccurred");
      const severity = data?.details?.severity || 'error';
      
      setNotification({
        show: true,
        message: `${errorType}: ${errorMessage}`,
        type: severity === 'error' ? 'error' : severity === 'warning' ? 'warning' : 'info',
      });

      const timeout = severity === 'error' ? 10000 : severity === 'warning' ? 7000 : 5000;
      setTimeout(
        () => setNotification({ show: false, message: "", type: "error" }),
        timeout
      );
    }

    // Handle store updates
    if (message.type === "STORES_UPDATED") {
      const { data } = message;
      console.log("Stores updated:", data);
      
      setNotification({
        show: true,
        message: t("productApiMsgs.storeListUpdated"),
        type: "info",
      });

      setTimeout(
        () => setNotification({ show: false, message: "", type: "info" }),
        5000
      );
    }
  };

  return () => {
    ws.close();
  };
}, [id, t]);
 
 const [isSubmitting, setIsSubmitting] = useState(false);
  // useEffect(() => {
  //   fetchStoreId();
  // }, []);

  useEffect(() => {
    console.log(storeId);
    
    if (storeId) fetchAppIdFromStore(storeId);
  }, [storeId]);

  const handleCloseModal = () => {
    setShowDeleteModal(false)
  }

const handleBulkDeleteItems = async () => {
  if (isPosReadOnlyEntity(catalog)) return;
  if (!selectedItems.productIds || selectedItems.productIds.length === 0) {
    toast.warning(t("No items selected for deletion"));
    return;
  }

  try {
    const token = localStorage.getItem("token");
    const payload = {
      productIds: selectedItems.productIds
    };

    await api.delete(`/v2.1/catalog/${id}/bulk-items`, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data: payload
    });

    toast.success(t("Selected items have been deleted successfully."));
    setSelectedItems({ productIds: [] }); // Clear selection
    await fetchCatalog();
  } catch (error) {
    console.error('Error deleting items:', error);
    const errorMessage = error.response?.data?.message || t("Failed to delete selected items");
    toast.error(errorMessage);
  } finally {
    setShowBulkDeleteModal(false);
  }
};

  // const fetchStoreId = async () => {
  //     try {
  //       const token = localStorage.getItem("token");
  //       const response = await api.get("/stores/my", {
  //         headers: { Authorization: `Bearer ${token}` },
  //       });
  
  //       if (!response.data?.stores?.length) throw new Error("No stores found.");
  //       setStoreId(response.data.stores[0]._id);
  //     } catch (error) {
  //       console.error("Error fetching store ID:", error);
  //       toast.error("Failed to fetch store.");
  //     }
  //   };
  
    const fetchAccountApps = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;
        const { apps: nextApps, addonApps: nextAddonApps } =
          await fetchPricedAppSources();
        setAccountApps(nextApps);
        setAddonApps(nextAddonApps);
      } catch (error) {
        console.error("Error fetching account apps:", error);
      }
    };

    useEffect(() => {
      fetchAccountApps();
    }, []);

    const fetchAppIdFromStore = async (storeId) => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("token");
        const response = await api.get(`/stores/${storeId}/apps?category=INTEGRATION`, {
          headers: { Authorization: `Bearer ${token}` },
        });
  
        setTiles(response?.data?.apps || []);
      } catch (error) {
        console.error("Error fetching App ID:", error);
        toast.error(`${t("Failed to fetch apps.")}`);
      } finally {
        setIsLoading(false);
      }
    };
   const handleDeleteCatalog = async () => {
  setDeleteLoading(true);
  setDeleteError(null);
  try {
    const token = localStorage.getItem("token");
    const response = await api.delete(`/v2.1/catalog/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (response.status === 200 || response.status === 204) {
      toast.success(t("Catalog deleted successfully."), {
        autoClose: 700,
        onClose: () => navigate("/catalog"),
      });
      setShowDeleteModal(false);
    }
  } catch (error) {
    setShowDeleteModal(false);
    console.error("Error deleting catalog:", error);
    toast.error(
      error.response?.data?.message || t("Failed to delete catalog.")
    );
  } finally {
    setDeleteLoading(false);
  }
};

   const handleConfirmSelection = async (appId) => {
    if (!canSyncCatalog) {
      toast.error(t("noPermissionToAccessThis"));
      return;
    }
    const payload = {
        appId: appId,
        catalogId: id,
    };

    try {
        setSubmittingAppId(appId); // Set the specific app ID being submitted
        const token = localStorage.getItem("token");

        const response = await api.post("/catalog/sync", payload, {
            headers: { Authorization: `Bearer ${token}` },
        });

        toast.success(`${t("Catalog synced successfully.")}`);
        fetchCatalog();
    } catch (error) {
        const message = error.response?.data?.message || `${t("Failed to sync catalog")}`;
        console.error("Error syncing catalog:", error);
        toast.error(message);
    } finally {
        setSubmittingAppId(null); // Reset when done
    }
};
  const fetchCatalog = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get(`/v2.1/catalog/${id}`, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Accept-Language': i18n.language // Send current language preference
        },
      });
      
      const catalogData = response.data.data;

      // Ensure we have the bilingual fields
      const processedCatalog = {
        ...catalogData,
        // Use the appropriate language field based on current language
        displayName: isArabic ? (catalogData.name_ar || catalogData.name) : (catalogData.name_en || catalogData.name),
        displayDescription: (
          isArabic
            ? (catalogData.description_ar || catalogData.description || catalogData.description_en)
            : (catalogData.description_en || catalogData.description || catalogData.description_ar)
        ) || null,
      };
      
      setCatalog(processedCatalog);
      setSortedItems(response.data.itemsSorted)
      if (catalogData.store) {
        setStoreId(catalogData.store._id || catalogData.store);
      }
      
      // Removed active catalog state update as it's no longer used
      
    } catch (error) {
      console.error("Error fetching catalog:", error);
      toast.error(error.response?.data?.message || t("Failed to load catalog details"));
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <MDBContainer fluid className="p-4 content-area flex-grow-1">
        <Skeleton height={40} width={220} style={{ marginBottom: 32 }} />
        <MDBRow className="mb-4">
          <MDBCol md="6">
            <Skeleton height={100} borderRadius={12} />
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol md="12">
            <Skeleton
              height={48}
              style={{ marginBottom: 8, borderRadius: 8 }}
              count={8}
            />
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    );
  }

  if (!catalog) {
    return (
      <MDBContainer className="text-center mt-5">
        <p>Catalog not found.</p>
      </MDBContainer>
    );
  }

  const catalogReadOnly = isPosReadOnlyEntity(catalog);
  const catalogDeleteLocked = isPosIntegrationDeleteLocked(catalog);
  const rowPosLocked = (row) =>
    catalogReadOnly || isPosReadOnlyEntity(row?.product);

  const handleModalClose = () => {
    console.log("Modal closed!");
    fetchCatalog(); // your custom function to run on close
    setShowModal(false);
    setIsModalOpen(false);
  };
  const handleEditItemClick = (item) => {
    if (isPosReadOnlyEntity(catalog) || isPosReadOnlyEntity(item)) return;
    console.log("Edit Item Click", item);
    navigate(`/product/${item._id}`);
  };

  //Handle visibility of the Product
  const handleVisibility = async (item, visibility) => {
    if (isPosReadOnlyEntity(catalog) || isPosReadOnlyEntity(item)) return;
    console.log("Confirmed!", item);
    const payload = {
      productId: item._id,
      isVisible: visibility,
      catalogId: id,
    };

    try {
      const token = localStorage.getItem("token");
      console.log("🔄 Sending Update visibility Payload:", payload);

      //  Correct API URL
      const response = await api.post(`hide-product`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log(" Item visibility updated Successfully:", response.data);

      await fetchCatalog();
    } catch (error) {
      console.error(
        " Error adding category:",
        error.response?.data || error.message
      );
      setError(error.response?.data?.message || t("Failed to add category."));
    }

    setShowConfirm(false); // Hide modal after confirming
  };
  

  // Handler to update modifier availability
  const handleModifierAvailability = async (
    modifier,
    isAvailable,
    catalogItemId
  ) => {
    if (isPosReadOnlyEntity(catalog)) return;
    try {
      console.log("catalogItemId", catalogItemId);
      const token = localStorage.getItem("token");
      await api.post(
        `/catalog/${id}/modifier-availability`,
        {
          modifierId: modifier.id,
          isAvailable,
          catalogItemId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      await fetchCatalog();
    } catch (error) {
      setError(
        error.response?.data?.message ||
          t("Failed to update modifier availability.")
      );
    }
  };

  return (
    <div className="catalog-details-page-root oh-page">
    <MDBContainer fluid className="content-area flex-grow-1">
      {/* Notification Popup */}
      {notification.show && (
        <div
          className={`alert alert-${
            notification.type === "success" ? "success" : "danger"
          } alert-dismissible fade show position-fixed`}
          style={{
            top: "20px",
            insetInlineEnd: "20px",
            zIndex: 9999,
            minWidth: "300px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}
          role="alert"
          dir={i18n.language === "ar" ? "rtl" : "ltr"}
        >
          <div className="d-flex align-items-center gap-2">
            <MDBIcon
              icon={
                notification.type === "success"
                  ? "check-circle"
                  : "exclamation-triangle"
              }
              className={
                notification.type === "success" ? "text-success" : "text-danger"
              }
            />
            <span className="fw-semibold">
              {notification.type === "success" ? t("Success!") : t("Error!")}
            </span>
          </div>
          <div className="mt-1">{notification.message}</div>
          <button
            type="button"
            className="btn-close"
            onClick={() =>
              setNotification({ show: false, message: "", type: "success" })
            }
            aria-label={t("close")}
          ></button>
        </div>
      )}

      {removeProductSuccess && (
        <div className="alert alert-success">{removeProductSuccess}</div>
      )}
      {removeProductError && (
        <div className="alert alert-danger">{removeProductError}</div>
      )}

      <h1 className="page-title-header">
        {catalog.displayName ||
          (isArabic ? catalog.name_ar : catalog.name_en) ||
          catalog.name}
      </h1>

      <div className="oh-page-section">
   <Actionbar
              title={t("quickAction")}
              subtitle={t("manageYouWorkSpace")}
              firstBtnText={t("editcatalog")}
              firstBtnOnClick={() => setModalOpen(true)}
              firstBtnClass="ocean"
              firstBtnIcon="pen"
              disabledBtn1={!canEditCatalog || catalogReadOnly}
              disabledBtn2={!canDeleteCatalog || catalogDeleteLocked}
              firstBtnTitle={
                catalogReadOnly
                  ? posReadOnlyTooltip(t, catalog)
                  : !canEditCatalog
                    ? t("noPermissionToAccessThis")
                    : undefined
              }
              secondBtnText={t("deletecatalog")}
              secondBtnOnClick={() => {
                setShowDeleteModal(true);
              }}
              secondBtnTitle={
                catalogDeleteLocked
                  ? posDeleteLockedTooltip(t, catalog)
                  : !canDeleteCatalog
                    ? t("noPermissionToAccessThis")
                    : undefined
              }
              secondBtnClass="reject-orders"
              secondBtnIcon="x"
            />
      </div>

  {catalogReadOnly && (
          <div className="alert alert-info py-2 px-3 my-3 mb-0" role="status">
            {t(catalogReadOnlyBannerKey(catalog))}
          </div>
        )}

<div className="oh-page-section">
<div className="px-0 py-3 py-md-4" style={{ backgroundColor: "#f8f9fa" }}>
  <div className="container-xxl p-0" style={{ height: 'auto', minHeight: '0' }}>
    
    {/* Single Row: All Three Cards - Stack on mobile */}
    <div className="row g-2 g-md-3">
      
      {/* Catalog Card - Full width on mobile */}
    <div className="col-12 col-md-6 col-lg-6">
  <div className="card h-100 shadow-sm border-0" style={{ overflow: 'visible' }}>
    <div className="card-header bg-white border-0 d-flex flex-wrap justify-content-between align-items-center gap-2 p-2 p-md-3">
      <div className="d-flex align-items-start">
        <Package className="text-primary flex-shrink-0" size={20} />
        <div className="ms-2">
          <h6 className="card-title mb-0 text-dark fw-semibold text-truncate" style={{ fontSize: '16px' }}>
          {catalog.displayName || (isArabic ? catalog.name_ar : catalog.name_en) || catalog.name}
          </h6>
         
        </div>
      </div>
     
    </div>

    <div className="card-body p-2">
      <div className="row g-2">
        <div className="col-12">
          <div className="p-2 d-flex flex-column gap-2">
 {/* Items Count */}
            <div className="d-flex align-items-center gap-2">
              <Package className="text-secondary flex-shrink-0" size={20} />
              <h6 className="text-muted fs-6 text-dark fw-bold m-0" style={{ fontSize: '12px' }}>
               {t("itemscount")}:{" "}
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#6c757d",
                    lineHeight: "1.4",
                  }}
                  className="mb-0"
                >
                  {catalog.items.filter((item) => item.product && item.product._id).length}
                </span>
              </h6>
            </div>

              <div className="d-flex align-items-center gap-2">
              <CalendarDays className="text-secondary flex-shrink-0" size={20} />
             
              <h6 className="text-muted fs-6 text-dark fw-bold m-0" style={{ fontSize: '12px' }}>
                {t("createdAt")}:{" "}
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "normal",
                    color: "#6c757d",
                    lineHeight: "1.4",
                  }}
                  className="mb-0"
                >
                 {catalog.createdAt ? new Date(catalog.createdAt).toLocaleDateString("en-GB") : "-"}
                </span>
              </h6>
            </div>

            {/* Description */}
            <div className="d-flex gap-2">
              <BookText className="text-secondary flex-shrink-0" size={20} />
              <div className="d-flex align-items-center gap-2">
                <h6 className="text-muted fs-6 text-dark fw-bold m-0" style={{ fontSize: '12px' }}>
                   {t("description")}:{" "}
                  <span
                    style={{
                      fontSize: "14px",
                    fontWeight: "normal",
                    color: "#6c757d",
                    lineHeight: "1.4",
                    }}
                    className="mb-0"
                  >
                    {catalog.displayDescription || (isArabic ? catalog.description_ar : catalog.description_en) || catalog.description || t("No description")}
                  </span>
                </h6>
              </div>
            </div>

           
      

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

     
<div className="col-12 col-md-6 col-lg-6">
  <div className="card h-100 shadow-sm border-0 overflow-hidden">
    <div className="card-header bg-white border-0 p-2 p-md-3">
      <div className="d-flex align-items-center">
        <RefreshCcwDotIcon className="text-warning flex-shrink-0" size={20} />
        <h6 className="card-title mb-0 ms-2 text-dark fw-semibold" style={{ fontSize: '16px' }}> {t("catalogsync")}</h6>
      </div>
    </div>
    <div className="card-body p-2">
      {/* App Cards Scrollable Section - Reduced maxHeight */}
      <div className="sync-apps-container">
        {tiles.length > 0 ? (
          
          tiles
            .filter((tile) => {
              const appName = (tile.application || '').toLowerCase();
              // Exclude Chat Agent, Digital Catalog, Foodics, and Tabsense
              return !appName.includes('chat') && 
                     !appName.includes('digital catalog') && 
                     !appName.includes('foodics') &&
                     !appName.includes('tabsense');
            })
            .map((tile) => {
             const matchedSyncedApp = catalog.syncedApps?.find(
    (syncedApp) => syncedApp.appId === tile._id
  );

  const isSynced = matchedSyncedApp?.synced_status === true;
           const syncedDate = matchedSyncedApp?.synced_date_time;
              return (
            <div key={tile._id} className="mb-2 p-2 rounded bg-light border d-flex justify-content-between align-items-center">
                <div className="d-flex gap-2 align-items-center">
                <div className="bg-secondary-subtle rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: 36, height: 36 }}>
                  {(() => {
      const platformKey = getPlatformKey(tile.application);
      const logo = platformLogos[platformKey];
      return logo ? (
        <img
          src={logo.src}
          alt={logo.alt}
          height={logo.height}
          style={{ objectFit: "contain", maxWidth: "100%" }}
        />
      ) : (
        <Package size={16} className="text-secondary" />
      );
    })()}
                </div>
                <div className="d-flex align-items-center">
                  <div className="fw-semibold text-dark" style={{ fontSize: "14px" }}>
                    {getLocalizedPlatformName(tile.application, t)}
                  </div>
                </div>                
              </div>
         <div className="sync-status-container">
  <div className="status-column">
   {!canSyncCatalog ? (
    <MDBTooltip tag="span" title={t("noPermissionToAccessThis")}>
      <span className="d-inline-block">
        <button
          type="button"
          className={`sync-status-button ${isSynced ? 'synced' : 'not-synced'}`}
          disabled
          style={{ pointerEvents: "none", opacity: 0.85 }}
        >
          {isSynced ? (
            <>
              <Check size={12} className="icon" />
              <span> {t("synced")}</span>
            </>
          ) : (
            <>
              <RefreshCw
                size={12}
                className={`icon flex-shrink-0 ${submittingAppId === tile._id ? "spin" : ""}`}
              />
              <span> {t("notsynced")}</span>
            </>
          )}
        </button>
      </span>
    </MDBTooltip>
   ) : (
   <button
    type="button"
    onClick={() => {
      if (!canSyncCatalog) return;
      setSelectedTile(tile);
      setShowCategorySyncModal(true);
    }}
    className={`sync-status-button ${isSynced ? 'synced' : 'not-synced'}`}
    disabled={submittingAppId === tile._id || !canSyncCatalog}
>
    {isSynced  ? (
        <>
            <Check size={12} className="icon" />
            <span> {t("synced")}</span>
        </>
    ) : (
        <>
            <RefreshCw 
                size={12} 
                className={`icon flex-shrink-0 ${submittingAppId === tile._id ? "spin" : ""}`} 
            />  
            <span> {t("notsynced")}</span>
        </>
    )}
</button>
   )}
  </div>
 {isSynced && syncedDate && (
  <div className="timestamp-column">
    <span className="timestamp">
      {new Date(syncedDate).toLocaleDateString(isArabic ? "ar-SA" : "en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })}{" "}
      {new Date(syncedDate).toLocaleTimeString(isArabic ? "ar-SA" : "en-US", {
        hour: "2-digit",
        minute: "2-digit",
      })}
    </span>
  </div>
)}

</div>

<style jsx>{`
  .sync-status-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
  }
.icon.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
  .status-column {
    display: flex;
    justify-content: flex-end;
  }

  .timestamp-column {
    display: flex;
    justify-content: flex-end;
  }

  .sync-status-button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    padding: 0.25rem 0.75rem;
    gap: 0.25rem;
    width: auto;
    font-size: 10px;
    min-height: 30px;
    line-height: 1.2;
    cursor: default;
    transition: all 0.2s ease;
    border: 1px solid;
  }

  .sync-status-button.synced {
   background-color: #dcfce7;
   color: #166534;
   width: 100px;
   border: 1px solid #bbf7d0;
  }
  .sync-apps-container {
  height: auto;
  max-height: 150px;
  overflow: auto;
}

@media (max-width: 768px) {
  .sync-apps-container {
    height: auto;
    max-height: 300px;
  }
}

  .sync-status-button.synced:hover {
background-color: #bbf7d0;/* Slightly darker green on hover */
  }
 
  .sync-status-button.not-synced {
  width: 100px;
    background-color: #f0f0f0; /* Light gray background */
    color: #424242;
    border-color: #9e9e9e; /* Medium gray border */
  }
 
  .sync-status-button.not-synced:hover {
  
    background-color: #e0e0e0; /* Slightly darker gray on hover */
  }
    
  
  .icon {
    flex-shrink: 0;
  }

  .timestamp {
    font-size: 12px;
    color: #616161; /* Dark gray for timestamp */
    line-height: 1.2;
  }

 
`}</style>

            </div>
          )})
        ) : (
          <div className="text-center text-muted py-4">
            <span style={{ fontSize: "24px" }}>📱</span>
            <p className="mb-0">{t("No apps found")}</p>
          </div>
        )}
      </div>
    </div>
  </div>
</div>

       {/* Store Card - Half width on mobile, full on larger */}
 <div className="col-12 col-md-6 col-lg-6">
        <div className="card h-100 shadow-sm border-0 overflow-hidden">
          <div className="card-header bg-white border-0 p-2 p-md-3">
            <div className="d-flex align-items-center">
              <Store className="text-success flex-shrink-0" size={20} />
              <h6 className="card-title mb-0 ms-2 text-dark fw-semibold" style={{ fontSize: '16px' }}> {t("storedetails")}</h6>
            </div>
          </div>
          <div className="card-body p-2">
            
                 
                    <div style={{backgroundColor: "transparent"}} className="">
                      <div className=" p-2 d-flex flex-column" style={{width: "100%",gap: "12px", backgroundColor: "transparent"}}>
                        <div className="d-flex gap-2 align-items-center">
                          <User className="text-secondary flex-shrink-0" size={20} />
                          
                            <h6 className="text-muted fs-6 text-dark fw-bold m-0" style={{ fontSize: '14px' }}> {t("name")}:<span style={{ fontSize: "13px", color: "#6c757d", lineHeight: "1.4", fontWeight: "normal" }}> {catalog.store?.name || "N/A"}</span></h6>
                           
                        
                        </div>
                        <div className="d-flex gap-2 align-items-center">
                          <Mail className="text-secondary flex-shrink-0" size={20} />
                          
                           <h6 className="text-muted fs-6 text-dark fw-bold m-0" style={{ fontSize: '14px' }}> {t("email")}: <span style={{ fontSize: "13px", color: "#6c757d", lineHeight: "1.4", fontWeight: "normal" }}>  <MDBTooltip tag="span" title={catalog.store?.email || 'N/A'} placement="top">
                             
                                {catalog.store?.email || 'N/A'}
                                                         </MDBTooltip></span></h6>
                          
                        
                        </div>
                        <div className="d-flex gap-2 ">
                          <MapPin className="text-secondary flex-shrink-0" size={20} />
                          <div>
                           <h6 className="text-muted fs-6 text-dark fw-bold m-0" style={{ fontSize: '14px' }}> {t("address")}: <span style={{ fontSize: "14px", color: "#6c757d", lineHeight: "1.4", fontWeight: "normal" }}> {catalog.store?.address || "N/A"}</span></h6>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                 
           
             
          </div>
        </div>
      </div>
      {/* Branch Card - Half width on mobile, full on larger */}
     
    </div>
  </div>
</div>
</div>

      <div className="oh-page-section">
<DeleteModal
        text={`Are you sure you want to delete ${selectedItems.productIds.length} items?`}
        showModal={Boolean(showBulkDeleteModal && canMutateCatalogLink)}
        confirmDelete={handleBulkDeleteItems}
        onClose={closeBulkDeteteModal}
      />
     
        <CatalogItemsTable
          sortedItems={sortedItems}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          canEditCatalog={canEditCatalog}
          canMutateCatalogLink={canMutateCatalogLink}
          catalogReadOnly={catalogReadOnly}
          catalog={catalog}
          rowPosLocked={rowPosLocked}
          isArabic={isArabic}
          t={t}
          handleWeightChange={handleWeightChange}
          handleVisibility={handleVisibility}
          handleModifierAvailability={handleModifierAvailability}
          handleEditItemClick={handleEditItemClick}
          handleModalOpen={handleModalOpen}
          deliveryApps={deliveryApps}
          toolbarExtra={
            <div className="d-flex gap-2 flex-wrap align-items-center">
              {!canMutateCatalogLink || catalogReadOnly ? (
                <MDBTooltip
                  tag="span"
                  title={
                    catalogReadOnly
                      ? posReadOnlyTooltip(t, catalog)
                      : t("noPermissionToAccessThis")
                  }
                >
                  <span className="d-inline-block">
                    <Button
                      color="danger"
                      className="d-flex align-items-center"
                      disabled
                      style={{ pointerEvents: "none" }}
                    >
                      <MDBIcon fas icon="trash" className="me-2" />
                      {t("deleteitem")}
                    </Button>
                  </span>
                </MDBTooltip>
              ) : (
                <Button
                  color="danger"
                  onClick={() => setShowBulkDeleteModal(true)}
                  className="d-flex align-items-center"
                  disabled={selectedItems.productIds.length === 0}
                >
                  <MDBIcon fas icon="trash" className="me-2" />
                  {t("deleteitem")}
                </Button>
              )}

              {!canEditCatalog || catalogReadOnly ? (
                <MDBTooltip
                  tag="span"
                  title={
                    catalogReadOnly
                      ? posReadOnlyTooltip(t, catalog)
                      : t("noPermissionToAccessThis")
                  }
                >
                  <span className="d-inline-block">
                    <Button disabled style={{ pointerEvents: "none" }}>
                      {t("additem")}
                    </Button>
                  </span>
                </MDBTooltip>
              ) : (
                <Button onClick={() => setShowModal(true)}>
                  {t("additem")}
                </Button>
              )}

              {!canEditCatalog || catalogReadOnly ? (
                <MDBTooltip
                  tag="span"
                  title={
                    catalogReadOnly
                      ? posReadOnlyTooltip(t, catalog)
                      : t("noPermissionToAccessThis")
                  }
                >
                  <span className="d-inline-block">
                    <Button
                      color="primary"
                      disabled
                      style={{ pointerEvents: "none" }}
                    >
                      {t("Save Changes")}
                    </Button>
                  </span>
                </MDBTooltip>
              ) : (
                <Button
                  color="primary"
                  onClick={handleBulkSaveWeights}
                  disabled={sortedItems.length === 0}
                >
                  {t("Save Changes")}
                </Button>
              )}
            </div>
          }
        />
 <DeleteModal text={t("areyousureyouwanttoremovethisitemfromcatalog")} showModal={Boolean(showDeleteModalforitem && canMutateCatalogLink)} confirmDelete={handleRemoveProduct} onClose={()=>setShowDeleteModalforitem(false)}/>
      </div>

      <CatalogModal
        show={Boolean(modalOpen && canEditCatalog && !catalogReadOnly)}
        setShow={setModalOpen}
        isEditMode={true}
        editData={catalog}
        onCatalogUpdate={fetchCatalog}
      />
      <DeleteModal
        text={t("areyousureyouwanttodeletethiscatalog")}
        showModal={Boolean(showDeleteModal && canDeleteCatalog && !catalogDeleteLocked)}
        confirmDelete={handleDeleteCatalog}
        onClose={handleCloseModal}
        isLoading={deleteLoading}
      />
      <CatalogItemModal
        show={Boolean(showModal && canEditCatalog && !catalogReadOnly)}
        setShow={setShowModal}
        catalogId={id}
        storeId={storeId}
        onClose={handleModalClose}
      />
      {selectedTile && (
        <CatalogSyncModal
          modalShow={Boolean(showCatalogSyncModal && canSyncCatalog)}
          tile={selectedTile}
          catalogId={id}
          appId={selectedTile._id}
          storeId={catalog?.store_id}
          itemCount={
            catalog?.item_count ??
            catalog?.items?.length ??
            0
          }
          syncAllowed={canSyncCatalog}
          onClose={closeCatalogSyncModal}
          onSyncSuccess={() => {
            closeCatalogSyncModal();
            fetchCatalog();
          }}
        />
      )}
    </MDBContainer>
    </div>
  );
};

export default CatalogDetails;
